<template>
  <div>
    <div class="container-fluid pt-4">
      <b-modal id="StoreAlertEdit" title="Admin" @ok="close()" ok-only>
        <p class="my-4">{{ message }}</p>
      </b-modal>
      <div class="col-xl-12">
        <div class="row">
          <div class="text-right col-xl-12">
            <b-form-checkbox switch size="s" v-model="form.status">Store active</b-form-checkbox>
          </div>
        </div>
      </div>
      <hr>
      <div class="row product-adding">
        <div class="col-xl-12">
          <div class="row product-adding">
            <div class="col-xl-6">
              <div class="digital-add needs-validation">
                <div class="form-group">
                  <label for="validationstorename" class="col-form-label pt-0">Store title
                    <span>*</span></label>
                  <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="id" type="hidden" v-model="form.id" />
                    <input class="form-control" id="validationstorename" type="text" v-model="form.title" required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="validationstorehostname" class="col-form-label pt-0">Store Hostname
                    <span>*</span></label>
                  <ValidationProvider name="host" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstorehostname" type="text" v-model="form.host"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="validationstoreemail" class="col-form-label pt-0">Store email</label>
                  <input class="form-control" id="validationstoreemail" type="email" v-model="form.email" />
                </div>
                <div class="form-group">
                  <label for="validationstorephone" class="col-form-label pt-0">Store phone</label>
                  <input class="form-control" id="validationstorephone" type="tel" v-model="form.phone" required="" />
                </div>
                <div class="form-group">
                  <label for="validationstoreaddress" class="col-form-label pt-0">Store address</label>
                  <input class="form-control" id="validationstoreaddress" type="text" v-model="form.adresse"
                    required="" />
                </div>
                <label>Store description</label>
                <vue-editor v-model="form.about"></vue-editor>
              </div>
              <!-- form end working -->
            </div>
            <div class="col-xl-6">
              <div class="digital-add needs-validation">
                <div class="form-group">
                  <label class="col-form-label pt-0">Logo Upload <span>*</span></label>
                  <!-- Le logo enregistré est affiché ici : l'aperçu du dropzone
                       ne peut pas le montrer. -->
                  <div class="mb-2" v-if="form.logo">
                    <img :src="form.logo" alt="Current logo" style="max-height: 70px; max-width: 100%;" />
                  </div>
                  <vue-dropzone id="ImagesLogo" :options="ImagesEditLogoOptions" class="dropzone digits" ref="ImagesLogo"
                    :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-removed-file="fileRemoved"
                    @vdropzone-file-added="logoFileAdded">
                  </vue-dropzone>
                  <small class="d-block text-muted" v-if="pendingLogoUpload">Uploading the logo...</small>
                  <small class="d-block text-muted" v-else-if="form.logo">Logo stored. Click Save to apply it to the store.</small>
                </div>
                <div class="form-group">
                  <label for="validationstoreecurrency" class="col-form-label pt-0">Store currency</label>
                  <select class="custom-select" required="" v-model="form.currency">
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="MAD">MAD</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="validationstoresymbol" class="col-form-label pt-0">Store currency symbol
                    <span>*</span></label>
                  <ValidationProvider name="symbol" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstoresymbol" type="text" v-model="form.symbol"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="validationstorecurrencyrate" class="col-form-label pt-0">Store currency rate
                    <span>*</span></label>
                  <ValidationProvider name="rate" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstorecurrencyrate" type="number" v-model="form.rate"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label class="col-form-label"><span>*</span> Language</label>
                  <select class="custom-select" required="" v-model="form.language">
                    <option value="English">English</option>
                    <option value="Frensh">Frensh</option>
                    <option value="Arabic">Arabic</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="validationstoremetatitle" class="col-form-label pt-0">Meta Title
                    <span>*</span></label>
                  <ValidationProvider name="metaTitle" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstoremetadescription" type="text" v-model="form.metaTitle"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="validationstoremetadescription" class="col-form-label pt-0">Meta Description
                    <span>*</span></label>
                  <ValidationProvider name="metaDescription" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstoremetatitle" type="text" v-model="form.metaDescription"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group">
                  <label for="validationstoremetakeyword" class="col-form-label pt-0">Meta Keyword
                    <span>*</span></label>
                  <ValidationProvider name="metaKeyword" rules="required" v-slot="{ errors }">
                    <input class="form-control" id="validationstoremetakeyword" type="text" v-model="form.metaKeywords"
                      required="" />
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12 pb-3 pt-3">
        <div class="form-group mb-0">
          <div class="product-buttons text-right">
            <button type="button" class="btn btn-primary" @click="save">
              Save
            </button>
          </div>
        </div>
      </div>
      <!-- Zone de suppression définitive : le nom de domaine doit être
           ressaisi à l'identique pour déverrouiller le bouton -->
      <div class="col-xl-12 pb-4">
        <div class="card" style="border-color: #e52e2e;">
          <div class="card-body">
            <h5 class="card-title text-danger">Delete this store</h5>
            <p class="card-text">
              This action is permanent. The store <strong>{{ id }}</strong>, its products, its
              articles and its subscribers will be deleted. Orders already placed are kept.
            </p>
            <div class="form-group">
              <label for="deleteconfirmation">
                To confirm the deletion, type the store domain name: <strong>{{ id }}</strong>
              </label>
              <input id="deleteconfirmation" type="text" class="form-control" v-model="deleteConfirmation"
                placeholder="Store domain name" autocomplete="off" />
            </div>
            <button type="button" class="btn btn-danger" :disabled="!id || deleteConfirmation !== id || deleting"
              @click="deleteStore">
              {{ deleting ? 'Deleting...' : 'Delete this store permanently' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Cookies from 'js-cookie';
export default {
  components: { VueEditor },
  data() {
    return {
      form: {},
      data: {},
      id: '',
      message: "",
      error: 0,
      deleteConfirmation: "",
      deleting: false,
      deleted: false,
      pendingLogoUpload: null,
      editor: ClassicEditor,
      tablefields: [
        { key: "image", label: "Image", sortable: false },
        { key: "actions" }
      ],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sliders: [],
      categories: [],
      slider: "",
      sliderid: "",
      index: null,
      selectMode: "single",
      ImagesEditLogoOptions: {
        // Dropzone exige une `url`, mais autoProcessQueue est désactivé :
        // aucun fichier n'est envoyé par le composant. L'envoi vers Firebase
        // Storage est fait directement dans logoFileAdded.
        url: "/no-op",
        autoProcessQueue: false,
        thumbnailWidth: 300,
        thumbnailHeight: 70,
        maxFiles: 1,
        maxfilesexceeded: function (file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        accept: function (file, done) {
          done();
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
    };
  },
  computed: {
    sortOptions() {
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    selectedRows() {
      return this.form.sliders.filter(item => item.delete);
    }
  },
  async mounted() {
    var data = await this.getStoresData();
    console.log(data);
    this.form = data[0];
    this.sliders = data[0].sliders;
    this.categories = data[0].categories;
  },
  methods: {
    async save() {
      // Un envoi de logo peut être en cours (l'image part dès que le fichier
      // est déposé) : on l'attend pour ne pas enregistrer l'ancienne URL.
      if (this.pendingLogoUpload) await this.pendingLogoUpload;
      if ((this.form.title == "") || (this.form.host == "") || (this.form.logo == "") || (this.form.symbol == "") || (this.form.rate == "")) {
        this.message = "Please complete all required fields!";
        this.error = 1;
        this.$bvModal.show('StoreAlertEdit');
        return false;
      } else {
        this.error = 0;
      }
      this.form.sliders = this.sliders;
      let ref = await firebase.firestore().collection('Sites').doc(this.form.host).set(this.form)
        .then(() => {
          this.message = "Document successfully written!";
          this.error = 0;
          this.$bvModal.show('StoreAlertEdit');
        })
        .catch((error) => {
          this.message = "Error writing document: " + error;
          this.error = 1;
          this.$bvModal.show('StoreAlertEdit');
        });
    },
    close() {
      if (this.deleted) {
        this.deleted = false;
        Cookies.remove('hostCookie');
        this.$router.push('/dashboard/default');
        return;
      }
      if (this.error == 0) this.$bvModal.hide('modal-StoreEdit' + this.id);
    },
    back() {
      this.$bvModal.hide('modal-StoreEdit' + this.id);
    },
    getIndex(id) {
      this.sliderid = id;
    },
    async deleteStore() {
      if (!this.id || this.deleteConfirmation !== this.id || this.deleting) return;
      this.deleting = true;
      const host = this.id;
      const fs = firebase.firestore();
      try {
        await this.deleteSubcollection(fs, 'Sites/' + host + '/Products');
        await this.deleteSubcollection(fs, 'Sites/' + host + '/Articles');
        await this.deleteSubcollection(fs, 'subscribers/' + host + '/email');
        await fs.collection('subscribers').doc(host).delete();
        await fs.collection('Sites').doc(host).delete();
        this.message = "Store " + host + " successfully deleted!";
        this.error = 0;
        this.deleted = true;
        this.$bvModal.show('StoreAlertEdit');
      } catch (error) {
        this.message = "Impossible to delete this store: " + error;
        this.error = 1;
        this.$bvModal.show('StoreAlertEdit');
      }
      this.deleting = false;
    },
    // Firestore n'autorise pas la suppression d'une sous-collection en une
    // seule commande depuis le navigateur : on efface les documents par
    // lots de 400 (limite : 500 écritures par lot).
    async deleteSubcollection(fs, path) {
      const snapshot = await fs.collection(path).get();
      let batch = fs.batch();
      let count = 0;
      for (const doc of snapshot.docs) {
        batch.delete(doc.ref);
        count++;
        if (count === 400) {
          await batch.commit();
          batch = fs.batch();
          count = 0;
        }
      }
      if (count > 0) await batch.commit();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formData(e) {
      this.sliders.push(e);
    },
    updateformData(e) {
      this.sliders[e.id] = e;
      this.$refs.tableSlider.refresh();
    },
    // Déclenché dès qu'un fichier est déposé : on lit le fichier nous-mêmes
    // (plus aucune dépendance au POST httpbin du template) et on l'envoie
    // vers l'API Hermes (stockage disque api/uploads).
    logoFileAdded(file) {
      if (!file || file._logoHandled) return;
      if (file.type && file.type.indexOf("image/") !== 0) return;
      if (file.size && file.size > 104857600) return;
      file._logoHandled = true;
      const upload = this.storeLogoFile(file);
      this.pendingLogoUpload = upload;
      upload.then(() => {
        if (this.pendingLogoUpload === upload) this.pendingLogoUpload = null;
      });
    },
    async storeLogoFile(file) {
      try {
        const dataURI = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = () => reject(reader.error || new Error("unreadable file"));
          reader.readAsDataURL(file);
        });
        this.form.logo = await this.get_url(this.dataURItoBlob(dataURI), file.name);
      } catch (error) {
        this.message = "Logo upload failed: " + error;
        this.error = 1;
        this.$bvModal.show('StoreAlertEdit');
      }
    },
    fileRemoved() {

    },
    uploadSuccess() {

    },
    imageResize(base64Str) {
      var img = new Image();
      img.src = base64Str;
      var canvas = document.createElement('canvas');
      var MAX_WIDTH = 300;
      var MAX_HEIGHT = 50;
      var width = img.width;
      var height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL();
    },
    showmodal() {
      this.$bvModal.show('modal-StoreEdit' + this.id);
    },
    async getStoresData() {
      let listData = [];
      var ProductRef = await firebase.firestore().collection("Sites")
        .where("host", "==", this.getStore())
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id = doc.id;
            listData.push(
              doc.data()
            );
          });
        });
      return listData;

    },
    onFileChange(event) {
      let picture = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(picture);
      reader.onloadend = (e) => {
        this.form.logo = e.target.result;
      };
    },
    clear() {
      this.form = {};
      this.sliders = [];
    },
    ok(e) {
      this.form.categories = e;
    },
    dataURItoBlob(dataURI) {
      // Extract the base64-encoded data from the Data URI
      var byteString = atob(dataURI.split(',')[1]);

      // Create an ArrayBuffer to hold the binary data
      var buffer = new ArrayBuffer(byteString.length);

      // Create a typed array from the buffer
      var uint8Array = new Uint8Array(buffer);

      // Populate the typed array with the binary data
      for (var i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      // Create a Blob from the ArrayBuffer, specifying the MIME type as 'image/webp'
      return new Blob([uint8Array], { type: 'image/webp' });
    },
    async get_url(file, filename) {
      // Téléversement vers l'API Hermes (stockage sur le disque du
      // serveur, dossier api/uploads) : remplace Firebase Storage
      // dont le bucket a dépassé le quota du plan gratuit Spark.
      if (!file) {
        return null;
      }
      // L'API refuse aussi # [ ] * ? dans les noms de fichiers.
      const safeName = String(filename || 'logo').replace(/[#\[\]*?]/g, '-');
      const ext = file.type === 'image/png' ? '.png' : '.webp';
      const form = new FormData();
      form.append('folder', 'sites/' + this.form.host + '/logo');
      form.append('file', file, safeName + ext);
      const res = await fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status + ' : /api/uploads injoignable (API Hermes démarrée ? proxy /api actif ?)');
      return data.url;
    },
    getStore() {
      const host = Cookies.get('hostCookie');
      if (host) {
        return host;
      } else {
        this.$router.push('/dashboard/default');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>